import angular from 'angular';

(function () {
  Endpoints.$inject = ["$log", "API_URL", "CMS_API_URL", "ADMIN_API_URL", "serverless_tracking_api_url", "serverless_api_url"];
  angular.module('pims').factory('Endpoints', Endpoints);
  /* @ngInject */
  function Endpoints(
    $log,
    API_URL,
    CMS_API_URL,
    ADMIN_API_URL,
    serverless_tracking_api_url,
    serverless_api_url,
    ) {
    const endpoints = {
      tracking: {
        base: `${serverless_tracking_api_url}tracking/v1/visits`,
        //POST
        uuid: `${serverless_tracking_api_url}tracking/v1/uuid` //GET

      },
      paymentMethods: {
        paymentService: 'content/web/paymentService',
        addPaymentMethod: 'admin/users/:user_id/paymentmethods',
        // object: `${API_URL}/transaction/object`,
        object: `admin/users/:user_id/paymentobjects`
      },
      cmsApi: {
        validateRoles: `${CMS_API_URL}/api/validate-roles`
      },
      redis: {
        base: `${CMS_API_URL}/api/cache`,
        key: `${CMS_API_URL}/api/cache/:key`
      },
      cancelledOrders: {
        statuses: `${serverless_api_url}cancelledorders/v1/statuses`,
        stores: `${serverless_api_url}cancelledorders/v1/stores`,
        orders: `${serverless_api_url}cancelledorders/v1/orders`,
        updateOrder: `${serverless_api_url}cancelledorders/v1/orders/:order_id-:dispense_order_id`
      },
      mailOrderPharmacies: {
        baseGet: `admin/mailorderpharmacies/`,
        medicationsWithStateCode: `admin/medications/states/:state_code/mailorderpharmacies`,
        basePut: `admin/medications/:medication_id/states/:state_code/mailorderpharmacy/`
      },
      scanwellMatching: {
        search: `${serverless_api_url}scanwellmatch/v1/unmatched/results`,
        one: `${serverless_api_url}scanwellmatch/v1/unmatched/results/:id`
      },
      scanwellResults: {
        search: `${serverless_api_url}scanwellreview/v1/admin/scanwell/results`,
        one: `${serverless_api_url}scanwellreview/v1/admin/scanwell/results/:id`,
        byOrderId: `${serverless_api_url}scanwellreview/v1/admin/scanwell/orders/:order_id`
      },
      scanwellShipping: {
        search: `${serverless_api_url}labs/v1/admin/orders/labs`,
        one: `${serverless_api_url}labs/v1/admin/orders/:order_id/labs/:order_lab_id`
      },
      content: {
        frontendParameters: 'content/web/frontendParameters',
        pimsParameters: 'content/web/pimsParameters'
      },

      aiDerm: {
        getAidermConfig: `${serverless_api_url}ai/autoderm/config`,
        postAiDermPimsToggle: `${serverless_api_url}ai/autoderm/config/pims/:product_category_id`,
        postAiDermBrochureToggle: `${serverless_api_url}ai/autoderm/config/brochure/:product_category_id`,
      },

      gpAddress: {
        getAllAddresses: 'admin/orders/gpaddresses/',
        getPendingGpLetters: `admin/orders/pendinggpletters/`,
        getPrintableGpLetters: `admin/orders/print-gp-letters`,
        updateAddress: `gpaddresses/:id`,
        printLetters: 'admin/orders/gpletters/generatepdf/',
        verifyLettersPrinted: 'admin/orders/markasprinted',
      },

      staffusers: {
        base: 'staffusers',
        one: 'admin/staffusers/:user_id',
        state: 'admin/staffusers/:user_id/licenses/:state_code',
        updateVideoStatus: 'admin/sessions',
        getVideoStatus: 'admin/sessions',
        getActiveUsers: 'admin/staffusers/activeclinicians',
        roles: 'admin/staffusers/:user_id',
        uploadUserSignature: 'admin/staffusers/:user_id/signature'
      },
      providers: {
        base: `${serverless_api_url}adminproviders/v1/admin/providers`,
        one: `${serverless_api_url}adminproviders/v1/admin/providers/:id`
      },
      users: {
        base: 'admin/users',
        one: 'admin/users/:id/details',
        authenticate: 'users/me/authenticate',
        me: 'users/me/details',
        activity: 'admin/users/:id/audit',
        rxKeyPair: 'users/me/rxkeypair',
        //search: 'admin/users/search',
        search: 'admin/users',
        matchedusers: 'admin/users/:id/matchedusers',
        updateMatchedusers: 'admin/users/:id/matchedusers/:matched_user_id',
        status: 'admin/users/:id/status',
        test: 'admin/users/:id/test',
        history: 'admin/users/:id/history',
        resetPassword: 'users/me/password/reset',
        properties: 'admin/users/:id/properties/:property',
        patientNotes: 'admin/users/:id/notes',
        patientNotesUpdate: 'admin/users/:id/notes/:user_note_id',
        videocalls: 'admin/users/:id/videocalls',
        deleteUser: 'admin/users/:user_id',
        subscriptions: 'admin/users/:user_id/subscriptions',
        defaultPaymentMethod: 'admin/users/:user_id/paymentmethods/default',
        reprocessPayment: 'admin/users/:user_id/subscriptions/charges/:subscription_charge_id/payments',
        cancelSubscription: 'admin/users/:user_id/subscriptions/:user_category_subscription_xref_id',
        cancelReasons: `${serverless_api_url}cancelreasons/v1/admin/cancelreasons`,
        pharmacies: 'admin/users/:user_id/pharmacies',
      },
      partnerUsers: {
        getPartnerLabs: `${CMS_API_URL}/admin/orders/:visit_id/partnerresultsets`
      },

      batching: {
        scheduleVisits: "admin/batches", // PUT;
        batchStatus: `${ADMIN_API_URL}/admin/orders/:id/batchstatus`, // GET;
        blockVisit: "admin/batch/block/:id",
        batchHistory: `admin/orders/:id/isbatchablehistory`,
        rules: 'admin/batches/rules',
        rule: 'admin/batches/rules/:id',
        ruleTypes: 'admin/batches/ruletypes',
      },

      orders: {
        payment: 'admin/orders/:id/prescriptions/payments',
        nonMedPayments: 'admin/orders/:id/nonmed/payments',
        //post
        base: 'admin/orders/',
        rejectionReasons: 'rejectionReasons',
        deny: 'admin/orders/:id/deny',
        denyByPST: 'admin/orders/:id/cancel',
        detail: 'admin/orders/:id',
        notes: 'admin/orders/:id/notes',
        summary: 'admin/summary',
        search: 'admin/orders',
        flags: 'admin/orders/:id/flags',
        responses: 'admin/orders/:id/responses',
        photos: 'admin/orders/:id/photos',
        delete_photo: 'admin/files/:id/photo-id',
        // diagnoses: '/images/labels/?type=:type',
        diagnoses: 'diagnoses?category=:type',
        treatment: 'admin/orders/:id/treatment',
        finalize: 'admin/orders/:id/finalise',
        pharmacy: 'admin/orders/:id/delivery',
        lock: 'admin/orders/:id/locks',
        lockAsPostApi: `${ADMIN_API_URL}/admin/orders/:id/locks/delete`,
        sendLabs: 'admin/orders/:id/labs',
        phonecalls: 'admin/orders/:id/phonecalls',
        videocalls: 'admin/orders/:id/videocalls',
        dosespothistorycounts: 'admin/orders/:id/dosespothistorycounts',
        flagDetails: 'admin/orders/:id/flags/:flag',
        getLabs: 'admin/users/:user_id/labs/resultsets/:id/pdf',
        getTestKitQR: `${serverless_api_url}labs/v1/admin/orders/:id/testkits/:tkid/qrcode`,
        // GET
        createTestKitQR: `${serverless_api_url}labs/v1/admin/orders/:id/testkits/:tkid/qrcode`,
        // POST
        getOrderTestKitsQR: `${serverless_api_url}labs/v1/admin/orders/:id/qrcode`,
        // GET
        getRecalculatedRefillPrice: `admin/orders/:orderId?refill=true`,
        createOrderTestKitsQR: `${serverless_api_url}labs/v1/admin/orders/:id/qrcode`,
        // POST
        getMailOrderHistory: 'admin/fillrequests/:id/updates',
        updateMailOrderStatus: 'admin/mailorders/:id/fillrequests/:frid?status=cancelled',
        categories: 'products/categories',
        updatePrescriptions: 'admin/orders/:id/prescriptions',
        lemonaidPharmacyMailorderSearch: 'admin/pharmacy/fills',
        lemonaidPharmacyMailorderOne: 'admin/pharmacy/fills/:id',
        getTreatmentPlans: 'admin/orders/:id/treatmentplanmessagetemplates',
        saveTreatmentPlans: 'admin/orders/:id/prescriptions/:prescription_id/treatmentplanmessagetemplate',
        getCallBooking: 'admin/orders/:id/callbooking'
      },
      // /admin/schedules/[a-z]+/bookings/dates/[0-9\-]+
      callBookings: {
        getTimes: 'admin/schedules/:schedule_code/bookings/dates/:date',
        // GET
        getDates: 'admin/schedules/:schedule_code/bookings/dates',
        // GET
        create: 'admin/schedules/:schedule_code/bookings',
        // POST
        delete: 'admin/schedules/:schedule_code/bookings/:id' // DELETE

      },
      pharmacies: {
        search: 'pharmacies/?lat=:lat&lng=:lng&radius=:radius',
        putManagerDetails: 'admin/pharmacies/:pharmacy_id',
      },
      categories: {
        base: 'admin/categories',
        pharmacyOptions: 'admin/categories/:id?include=pharmacy_options'
      },
      pharmacyPriceMedications: {
        byService: `${CMS_API_URL}/admin/medications/:category_code`
      },
      medications: {
        listByService: `${CMS_API_URL}/admin/medications/all/:category_code`
      },
      treatmentPlan: {
        codes: `${CMS_API_URL}/api/resultcontent/codes`
      },
      products: {
        byService: 'products?category=:category_code',
        listByService: 'categories/:category_code/products'
      },
      products_adminsvc: {
        productsAll: `${serverless_api_url}adminsvc/v1/products`,
        productsByService: `${serverless_api_url}adminsvc/v1/products?service_code=:service_code`,
        productByCode: `${serverless_api_url}adminsvc/v1/products/:code`,
        cloneProduct: `${serverless_api_url}adminsvc/v1/products/:code/clones`
      },
      groups: {
        adminProductGroups: `${serverless_api_url}adminsvc/v1/productgroups`,
        adminProductGroupOne: `${serverless_api_url}adminsvc/v1/productgroups/:code`,
        categories: `products/categories`,
        productGroupsByServiceCode: `categories/:code/productgroups`,
        productsByServiceCode: `categories/:code/products`,
      },
      messages: {
        send: 'messages',
        base: 'admin/users/:id/messages',
        pool: 'admin/messages/pool',
        markThread: 'messages/thread/seen',
        update: 'admin/messages/:id/',
        categories: 'admin/messages/categories/',
        locking: 'admin/users/:id/messages/lock',
        unreadPool: 'admin/messages'
      },
      business: {
        base: 'admin/business',
        slvhours: 'admin/states?slv=true',
        hours: 'admin/business/hours',
        slv: 'admin/business/status',
        slvState: 'admin/states/:code',
        holidays: 'admin/business/holidays',
        areacodes: 'areacodes',
        availableStates: 'states',
        allStates: 'admin/states',
        slvOpen: 'business/hours?zip=94105',
        getAllRoles: 'admin/users/roles'
      },
      meta: {
        base: 'meta/',
        status: 'meta/status/',
        summary: 'admin/summary/?type[]=banner&type[]=funnel'
      },
      promos: {
        base: 'admin/promos'
      },
      queue: {
        base: 'admin/queue/entries',
        one: 'admin/queue/entries/:id',
        audit: 'audits/queue'
      },
      files: {
        one: 'files/:id'
      },
      tasks: {
        one: 'tasks/:id',
        status: 'tasks/:id/status',
        callCompleted: 'admin/orders/:id/call'
      },
      dosespot: {
        patient: 'admin/dosespot/patient',
        userRxHistory: 'admin/users/:id/prescriptions',
        userAllergy: 'admin/users/:id/allergies'
      },
      google: {
        geocode: 'https://maps.googleapis.com/maps/api/geocode/json?address=:address&key=:key',
        timezone: 'https://maps.googleapis.com/maps/api/timezone/json?location=',
        geocodeAddress: 'https://maps.googleapis.com/maps/api/geocode/json?address=',
        geocodeLatLng: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=',
        geolocation: 'https://www.googleapis.com/geolocation/v1/geolocate?key='
      },
      plans: {
        medications: 'admin/orderlines/:orderline_id/medications',
        treatment: 'pages/:treatment'
      },
      slackNotifications: {
        completeVisitTest: 'https://hooks.slack.com/services/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',
        completeVisitProduction: 'https://hooks.slack.com/services/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',
        lemonaidVisitProduction: 'https://hooks.slack.com/services/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',
        lemonaidVisitTest: 'https://hooks.slack.com/services/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'
      },
      mailorder: {
        mailorderDeliveryType: 'admin/mailorders/:mail_order_id',
        //put
        createFill: 'admin/mailorders/:id/fills',
        //Post
        updateFill: 'admin/mailorders/:id/fills/:fid',
        //PUT
        FillPayment: 'admin/mailorders/:id/fills/:fid/payments',
        //post
        fillProcess: 'admin/mailorders/:id/fills/:fid/requests',
        //POSt
        mailorderChargeCompleteVisit: 'admin/orders/:id/medications/charge',
        mailorderChargeRefill: 'admin/mailorders/:mail_order_id/medications/charges',
        mailorderDetails: 'admin/orders/:id/medications?include=mail_orders',
        sendRefills: 'admin/truepill/fillrequests',
        updateRefills: 'admin/truepill/fillrequests/:fill_request_id',
        refillsData: 'admin/truepill/fillrequests/formdata?order_line_medication_id=:order_line_medication_id',
        sendTransferRequests: 'admin/truepill/transferrequests',
        getRefillInfo: 'admin/mailorders/:mail_order_id',
        updateRefillInfo: 'admin/mailorders/:mail_order_id',
        reprocessFillRequest: 'admin/mailorders/:mail_order_id/fillrequests/:mail_order_fill_request_id',
        deleteFillRequest: 'admin/mailorders/:mail_order_id/fills/:fill_id',
        cancelMailorder: 'admin/mailorders/:id',
        updateMailOrderPharmacy: "admin/orders/:mail_order_id/prescriptions/:prescription_id"
      },
      review: {
        NPVisit: `${serverless_api_url}revieworder/v1/admin/orders/:id/review`
      },
      outboundVisit: {
        baseGet: `${serverless_api_url}followups/v1/admin/orders`,
        callStatuses: `${serverless_api_url}followups/v1/admin/callstatuses`,
        updateCallStatus: `${serverless_api_url}followups/v1/admin/orders/:id/followup`
      }
    };

    function iterate(o, fn) {
      if (!angular.isObject(o)) {
        return o;
      }

      for (const k in o) {
        if (o.hasOwnProperty(k)) {
          if (angular.isObject(o[k])) {
            iterate(o[k], fn);
          } else {
            o[k] = fn(o[k]);
          }
        }
      }
    }

    iterate(endpoints, key => {
      return key.indexOf('http') < 0 ? `${API_URL}/${key}` : key;
    });
    return endpoints;
  }
})();
